export default __webpack_public_path__ + "static/media/has_noti.75c225cb.svg";